const TheUsagePage = () =>
  import('@/views/settings/funeralManager/TheUsagePage.vue')
const TheBatchOperationPage = () =>
  import('@/views/settings/funeralManager/batchOperation/TheBatchOperationPage.vue')

export const settingsFuneralManagerRoutes = [
  {
    path: 'usage',
    children: [
      {
        path: '',
        name: 'settings_usage_route',
        component: TheUsagePage,
        props: { view: 'dossiers' }
      },
      {
        path: 'consumables',
        name: 'settings_usage_consumables_route',
        component: TheUsagePage,
        props: { view: 'consumables' }
      },
      {
        path: 'ai',
        name: 'settings_usage_ai_route',
        component: TheUsagePage,
        props: { view: 'ai' }
      }
    ]
  },
  {
    path: 'batch-operations',
    name: 'settings_batch_operation_route',
    component: TheBatchOperationPage
  }
]
